import { render, staticRenderFns } from "./TopPostersList.vue?vue&type=template&id=4e72df53&scoped=true&"
import script from "./TopPostersList.vue?vue&type=script&lang=js&"
export * from "./TopPostersList.vue?vue&type=script&lang=js&"
import style0 from "./TopPostersList.vue?vue&type=style&index=0&id=4e72df53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72df53",
  null
  
)

export default component.exports